module.exports = __webpack_public_path__ + "static/media/Jacob_Okun_Picture.467d6a73.jpg";